import { defineStore } from 'pinia';
import { i18n } from '@/i18n';
import { axios } from '@/Services/Backend';
import { registerUserPrivateChannels, unregisterUserPrivateChannels, subscribeToSharedCart, unsubscribeFromSharedCart } from '@/notifications';
import { showSuccess } from '@/Mixins/HelperFunctions';

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        notifications: [],
    }),

    actions: {
        initialize() {
            this.getFromDatabase();

            registerUserPrivateChannels();
        },

        logout(userId, branchId, sellerId = null) {
            unregisterUserPrivateChannels(userId, branchId, sellerId);
        },

        subscribeSharedCart(branchId, prevBranchId = null, userId = null, sellerId = null) {
            subscribeToSharedCart(branchId, prevBranchId, userId, sellerId);
        },

        unsubscribeSharedCart(branchId, sellerId = null) {
            unsubscribeFromSharedCart(branchId, sellerId);
        },

        add(notification) {
            this.notifications.unshift(notification);
        },

        markAsRead(notification) {
            if (!notification.read) {
                axios
                    .post(`/api/notifications/${notification.id}`)
                    .then(() => {
                        const notificationToUpdate = this.notifications.find((it) => it.id === notification.id);
                        notificationToUpdate.read = true;

                        showSuccess(i18n.t('toasts.notificationRead'));
                    })
                    .catch((error) => {
                        console.log('Não foi possível marcar a notificação como lida. Tente novamente mais tarde.', error);
                    });
            }
        },

        markAllAsRead() {
            axios
                .post('/api/notifications/all/read')
                .then(() => {
                    this.notifications.forEach((notification) => {
                        notification.read = true;
                    });

                    showSuccess(i18n.t('toasts.allNotificationsRead'));
                })
                .catch((error) => {
                    console.log('Não foi possível marcar as notificações como lidas. Tente novamente mais tarde.', error);
                });
        },

        getFromDatabase() {
            axios.get('/api/notifications').then((response) => {
                this.notifications = response.data ?? [];
            });
        },
    },

    getters: {
        getNotifications: (state) => {
            return state.notifications;
        },
    },
});
